export enum MetadataType {
  Text = 'Text',
  Number = 'Number',
  Currency = 'Currency',
  Date = 'Date',
  Boolean = 'Boolean',
  File = 'File',
  // Liste
  Array = 'Array'
}

/**
 * Decodifica come stringa
 */
// TODO Liste (tipo = "entita")
// TODO/HI Altri tipi booleani ecc.
export function decodeMetadataType(type: string) {
  switch (type) {
    case 'string':
      return MetadataType.Text;
    case 'integer':
      return MetadataType.Number;
    case 'double':
      return MetadataType.Number;
    case 'date':
      return MetadataType.Date;
  }
}
